import {
    addBackgroundToCookieBanner,
    setBingConsentGrantedOnOsanoBannerAccepted,
    dateWithMonthsOffset,
    getCookie,
    getCurrentPage,
} from './es6/utils'

var currentPage = $('[name="current_page"]').val()

const inIframe = () => window.self !== window.top

// init Live Chat for all pages except for Help Center / Trial / API docs / Terms when served in iframe
if (currentPage !== 'help' && currentPage !== 'api_documentation' && currentPage !== 'trial') {
    if (!inIframe()) {
        initLiveChat()
    }
}

switch (currentPage) {
    case 'home':
        $(document).ready(function () {
            if (window.matchMedia('(min-width: 800px)').matches) {
                $('#quick_sign_up').sticky({ topSpacing: 0 })
            } else {
            }
        })

        // PLAY PAUSE VIDEO DEPENDING ON VIEWPORT
        $(document).scroll(function () {
            var video = $('#doc_editor_vid')

            if (video.is(':in-viewport')) {
                video[0].play()
            } else {
                video[0].pause()
            }
        })
        break

    case 'features':
        $(document).ready(function () {
            if (window.matchMedia('(min-width: 800px)').matches) {
                $('#quick_sign_up').sticky({ topSpacing: 0 })
            }
        })
        break

    case 'api_documentation':
    case 'help':
        $(document).ready(function () {
            if (window.matchMedia('(min-width: 800px)').matches) {
                $('#sticky').sticky({ topSpacing: 0 })
                //$("#sidebar_content").sticky({topSpacing:50});
            }
        })
        break

    case 'eversign_integrations':
        $(document).ready(function () {
            const zapierPopup = window.popup.register('zapier-popup', {
                center: true,
            })

            $('#open-zapier-popup').click(function (e) {
                window.popup.open(zapierPopup)
                return false
            })

            $('.popup-close').click(function () {
                window.popup.close(zapierPopup)
            })
        })
        break
}

/* CUSTOM PLAN FORM MARK IF TOUCHED */
$('body').on(
    'focus',
    '.custom_plan_builder form input, .custom_plan_builder form textarea',
    function () {
        $('.custom_plan_builder form').addClass('touched')
    },
)

$('body').on('click', '[href="/pricing#quote"]', function () {
    $('.custom_plan_builder form').addClass('touched')
})

/* INIT LIVE CHAT */
function initLiveChat() {
    if (!window.fcWidget) {
        return
    }

    window.fcWidget.init({
        token: '1378c725-5299-4612-a407-2dbc1661ac2c',
        host: 'https://wchat.freshchat.com',
    })

    // Set user details if user logged in
    if ($.isNumeric($('body').find('[name="apl_id"]').val())) {
        window.fcWidget.setExternalId($('body').find('[name="apl_id"]').val())
        window.fcWidget.user.setFirstName($('body').find('[name="apl_fn"]').val())
        window.fcWidget.user.setEmail($('body').find('[name="apl_em"]').val())

        // To set user properties
        /*
		  window.fcWidget.user.setProperties({
			plan: "Estate",
			status: "Active"
		  });
		  */
    }

    // pop open the chat after 30s on selected pages
    var autoOpenPages = ['pricing', 'api']

    if ($.inArray(currentPage, autoOpenPages) !== -1) {
        setTimeout(function () {
            // if chat not already open and if window is not mobile-sized
            if (
                window.fcWidget.isOpen() != true &&
                $(window).width() > 400 &&
                !$('body').find('.custom_plan_builder form').hasClass('touched')
            ) {
                window.fcWidget.open()
            }
        }, 30000)
    }
}

/* HOVER SVG ANIMATION */
$('body').on('mouseover', '[data-animation-type]', function () {
    $('section.use_cases').attr('class', 'use_cases').addClass($(this).attr('data-animation-type'))
})

/* DEPARTMENT SWITCHER */
$('body').on('click', '[data-choose-department]', function () {
    $('[data-choose-department]').removeClass('selected')
    $(this).addClass('selected')
    $('ul.dept').hide()
    $('ul.dept.' + $(this).attr('data-choose-department')).show()
})

/* FREQUENCY SWITCH PRICING */
$('body').on('click', '[data-change-frequency]', function () {
    var freq = $(this).attr('data-change-frequency')

    $('.frequency_switch a').removeClass('selected')
    $('.frequency_switch a.' + freq).addClass('selected')

    $('ul.tiers')
        .find('li')
        .not('li.custom')
        .not('li.free')
        .each(function () {
            $(this)
                .find('p.price span')
                .html(
                    '$' +
                        $(this)
                            .find('p.price span')
                            .attr('data-' + freq + '-price'),
                )

            $(this).closest('section.pricing.api').removeClass('monthly')
            $(this).closest('section.pricing.api').removeClass('yearly')

            $(this).closest('section.pricing.api').addClass(freq)

            /*if (freq === 'monthly') {
		$(this).find('small.frequency').html('per month');
		} else {
		$(this).find('small.frequency').html('per month');
		}*/
        })
})

/* HELP CENTER EXPAND SECTION */
$('body').on(
    'click',
    '.apilayer_documentation .sidebar .inner #sidebar_content > section h4',
    function () {
        if ($(this).closest('section').find('ul').is(':visible')) {
            return false
        }

        $('.apilayer_documentation .sidebar .inner #sidebar_content > section').removeClass(
            'selected',
        )
        $(this).closest('section').addClass('selected')

        $('.apilayer_documentation .sidebar .inner #sidebar_content > section ul').slideUp(100)
        $(this).closest('section').find('ul').slideDown(100)
    },
)

/* HELP CENTER SEARCH */
$(document).click(function (event) {
    if (!$(event.target).parents('.search').length) {
        $('body').find('.search_results').hide()
    }
})

$('body').on('keyup', '[name="search_help_center"] input', function () {
    $('body').find('.search_results ul').html('')
    $('body').find('.search_results').hide()

    var searchVal = $.trim($(this).val().toLowerCase())
    var categoryLinks = []

    var resultsNumber = 0

    if (searchVal) {
        // loop through all category links and add them to array
        $('body')
            .find('#sidebar_content a')
            .each(function () {
                var arrayObject = []

                var anchorTag = $(this).closest('li').html()
                var anchorText = $(this).text().toLowerCase()

                arrayObject.tag = anchorTag
                arrayObject.text = anchorText

                if (anchorText.indexOf(searchVal) >= 0) {
                    resultsNumber++
                    categoryLinks.push(arrayObject)
                }
            })
    }

    if (resultsNumber > 0) {
        // show dropdown structures
        $('body').find('.search_results').show()

        // loop through filtered results array and add them to dropdown
        $.each(categoryLinks, function (i) {
            $('body')
                .find('.search_results ul')
                .append('<li>' + categoryLinks[i].tag + '</li>')
        })
    }
})

/* PRICING PAGE LINE ITEM INFO POPUP */
$('body').on('mouseover', '.pricing .features_container ul li[data-info-popup]', function () {
    console.log('test')
    var thisInfoText = $(this).attr('data-info-popup')

    $('body').find('.infopopup_open').removeClass('infopopup_open')
    $(this).addClass('infopopup_open')
})

$('body').on('mouseout', '.pricing .features_container ul li[data-info-popup]', function () {
    $('body').find('.infopopup_open').removeClass('infopopup_open')
})

/* PRICING PAGE LINE ITEM INFO POPUP */
$('body').on('mouseover', '.pricing-plan-item ul li[data-info-popup]', function () {
    var thisInfoText = $(this).attr('data-info-popup')

    $('body').find('.infopopup_open').removeClass('infopopup_open')
    $(this).addClass('infopopup_open')
})

$('body').on('mouseout', '.pricing-plan-item ul li[data-info-popup]', function () {
    $('body').find('.infopopup_open').removeClass('infopopup_open')
})

function addPromotionalBanner() {
    const cookieName = 'hide_pricing_promo_banner'
    const hasCookieSet = getCookie(cookieName)

    // do not show this banner second time user comes to this page
    if (hasCookieSet) {
        return
    }

    const timeout = 60000 // 1 min
    const bannerContainer = document.body
    const bannerDOM = `
	<div class="promo-banner-overlay hidden">
		<div id="promotional-banner-pricing-page" class="promo-banner">
			<div class="promo-banner-header">
				<h2 style="text-align: center; line-height:30px; color: #fff !important">Try Xodo Sign Professional <br>for 14 days 100% FREE!</h2>
				<button class="promo-banner-close-btn"></button>
			</div>
			<div class="promo-banner-body">
				<p>Sign up today and try all the features of Xodo Sign Professional Plan <br>(normally $49.99 per month).</p>
				<p>Send unlimited documents to an unlimited number of signers! Invite colleagues to use your trial too!</p>
				<h3>Explore Xodo Sign Professional Free - No credit card required!</h3>
			</div>
			<div class="promo-banner-footer">
				<a href="https://eversign.com/trial/pricing" target="_blank">Sign Up Free Now</a>
			</div>
		</div>
	</div>`
    bannerContainer.insertAdjacentHTML('afterbegin', bannerDOM)

    const bannerEl = document.querySelector('.promo-banner-overlay')
    const closeBtn = document.querySelector('.promo-banner-close-btn')

    closeBtn &&
        closeBtn.addEventListener('click', () => {
            bannerEl && bannerContainer.removeChild(bannerEl)
            return
        })

    const bannerRevealTimer = setTimeout(() => {
        if (!bannerEl) {
            return
        }

        bannerEl && bannerEl.classList.remove('hidden')

        const cookieExpiryDate = dateWithMonthsOffset(12)
        document.cookie = `${cookieName}=1; expires=${cookieExpiryDate}; SameSite=Lax`

        clearTimeout(bannerRevealTimer)
    }, timeout)
}

document.addEventListener('DOMContentLoaded', () => {
    const mobileMenu = document.getElementById('marketing-page-mobile-menu')
    const hamburgerButton = document.getElementById('hamburger')

    if (mobileMenu && hamburgerButton) {
        let isMenuExpanded = false

        document.getElementById('hamburger').addEventListener('click', function (e) {
            e.preventDefault()

            if (isMenuExpanded) {
                mobileMenu.classList.remove('expanded')
                // prevent scrolling of background when mobile menu is expanded
                document.body.classList.remove('stop-scrolling')
                hamburgerButton.classList.remove('close')
                isMenuExpanded = false
            } else {
                mobileMenu.classList.add('expanded')
                document.body.classList.add('stop-scrolling')
                hamburgerButton.classList.add('close')
                isMenuExpanded = true
            }
        })
    }

    addBackgroundToCookieBanner()
    setBingConsentGrantedOnOsanoBannerAccepted()

    // EVR-10953
    if (getCurrentPage() === 'pricing') {
        addPromotionalBanner()
    }
})
